function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PerfectScrollbar from "perfect-scrollbar";
var OMCD = /*#__PURE__*/function () {
  function OMCD() {
    _classCallCheck(this, OMCD);
    this.$body = document.body;
    this.$page = document.querySelector(".omcd-page");
    this.$smallSlider = false;
    this._makeMenuItemActive(1193, ["archive", "single"]);
    this._makeMenuItemActive(1195, ["archive", "single"]);
    var pDropdown = document.getElementById("project-dropdown");
    if (pDropdown) {
      pDropdown.addEventListener("change", function (e) {
        var value = e.target.value;
        if (value) {
          location.href = document.querySelector("#" + value + " a").getAttribute("href");
        }
      });
    }
    var is_xs = window.innerWidth < 768;
    if (!is_xs) {
      document.querySelectorAll(".omcd-project__wrapper, .scroll-content, .js-scroll").forEach(function (element) {
        var s = new PerfectScrollbar(element);
        s.update();
      });
    }
  }
  return _createClass(OMCD, [{
    key: "_changeTitle",
    value: function _changeTitle(index, height) {
      this.$titleWrapper.style.marginTop = "-".concat(index * height, "px");
    }
  }, {
    key: "_makeMenuItemActive",
    value: function _makeMenuItemActive(id, searchIn) {
      var $menuItem = document.querySelector("#menu-item-" + id);
      var l = searchIn.length;
      console.log($menuItem);
      for (var i = 0; i < l; i++) {
        if (document.body.classList.contains(searchIn[i]) && $menuItem) {
          $menuItem.classList.add("active");
          return false;
        }
      }
    }
  }]);
}();
export { OMCD as default };